import React, { useCallback } from 'react'
import GlSpacer from '../../../share/GlSpacer'
import { ReactComponent as CrossIcon } from '../../../../assets/icons/app/cross.icon.svg'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import {
  selectAnalyticDetailsStateAnalyticDetailsAuthorsOutput,
  selectAnalyticDetailsStateAuthorDetailsSelected,
  selectAnalyticDetailsStateBookDetailsSelected,
} from '../../../../store/getters/analytics-details/analytic-details-v2.getters'
import {
  analyticDetailsV2StateGetAuthorDetailsData,
  analyticDetailsV2StateGetBookDetailsData,
} from '../../../../store/actions/analytics-details/analytic-details-v2.actions'
import AnalyticDetailsTable from '../../../analytics-details-v2/view/author-mirror/table/AnalyticDetailsTable'
import { AuthorMirrorAuthorInterface } from '../../../../core/interface/report/author-mirror-author.interface'

const ShareAnalyticDetailsAuthorMirrorList = ({
  authorIdHovered,
  handleCloseList,
}: {
  authorIdHovered: string | null
  handleCloseList: () => void
}) => {
  const onClickCloseButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    handleCloseList()
  }

  const authorsOutput = useAppSelector(
    selectAnalyticDetailsStateAnalyticDetailsAuthorsOutput,
  )

  const authorDetailsSelected = useAppSelector(
    selectAnalyticDetailsStateAuthorDetailsSelected,
  )

  const dispatch = useAppDispatch()

  const bookDetailsSelected = useAppSelector(
    selectAnalyticDetailsStateBookDetailsSelected,
  )

  const handleCloseBookDetails = useCallback(() => {
    void dispatch(
      analyticDetailsV2StateGetBookDetailsData({ bookDetails: null }),
    )
  }, [bookDetailsSelected])

  const handleAuthorSelected = useCallback(
    (authorDetails: AuthorMirrorAuthorInterface | null) => {
      if (!authorDetails) {
        return
      }

      void dispatch(
        analyticDetailsV2StateGetAuthorDetailsData({ authorDetails }),
      )

      handleCloseBookDetails()
    },
    [authorDetailsSelected],
  )

  return (
    <div className="flex flex-col basis-1/3 gap-4">
      <div className="flex flex-row items-center justify-between">
        <GlSpacer />
        <button
          type="button"
          className="flex flex-row items-center justify-center gap-2 p-2 bg-[#e9e9e9] rounded"
          onClick={onClickCloseButton}
        >
          <CrossIcon className="w-4 h-4" />
          <span>Fermer</span>
        </button>
      </div>
      <div className="relative flex-auto flex flex-col rounded-xl bg-white">
        <AnalyticDetailsTable
          authorDetailsSelected={authorDetailsSelected}
          authorsOutput={authorsOutput}
          isLoadingReloadOutput={false}
          handleAuthorSelected={handleAuthorSelected}
          authorIdHovered={authorIdHovered}
        />
      </div>
    </div>
  )
}

export default ShareAnalyticDetailsAuthorMirrorList
